module.exports = __webpack_public_path__ + "static/img/lx-bg.2af2899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lx-bg.jpg
// module id = Alp7
// module chunks = 1